import { useState, useCallback } from 'react';
import { api, uploadWeddingImage } from '../lib/api';
import { useAdminAuth } from '../contexts/AdminAuthContext';

export const useImageUpload = (weddingId) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const { token } = useAdminAuth();

  const uploadImage = useCallback(
    async (file) => {
      if (!token) {
        throw new Error('Not authenticated');
      }

      setUploading(true);
      setError(null);
      setProgress(0);

      try {
        // Simulate progress for better UX
        const progressInterval = setInterval(() => {
          setProgress((prev) => Math.min(prev + 10, 90));
        }, 100);

        const result = weddingId
          ? await uploadWeddingImage(token, weddingId, file)
          : await api.uploadImage(file, token);

        clearInterval(progressInterval);
        setProgress(100);

        return result;
      } catch (err) {
        setError(err.message);
        throw err;
      } finally {
        setUploading(false);
      }
    },
    [token, weddingId]
  );

  const reset = useCallback(() => {
    setUploading(false);
    setProgress(0);
    setError(null);
  }, []);

  return {
    uploadImage,
    uploading,
    progress,
    error,
    reset,
  };
};
